export default {
	common: {
		appName: "Comms Service",
		signIn: "Sign In",
		signUp: "Sign Up",
		signOut: "Sign Out",
		signInRequired: "Authentication Required",
		signInRequiredDescription: "Please sign in to access the dashboard.",
		dontHaveAccount: "Don't have an account?",
		loading: "Loading...",
		save: "Save",
		cancel: "Cancel",
		delete: "Delete",
		create: "Create",
		edit: "Edit",
		confirm: "Confirm",
		search: "Search",
		noResults: "No results found",
		creating: "Creating...",
		createSuccess: "Created successfully",
		updating: "Updating...",
		updateSuccess: "Updated successfully",
		deleting: "Deleting...",
		deleteSuccess: "Deleted successfully",
		copied: "Copied to clipboard",
	},
	nav: {
		dashboard: "Dashboard",
		messages: "Messages",
		organizations: "Organizations",
		apiKeys: "API Keys",
		senderIdentities: "Sender Identities",
		apiDocs: "API Docs",
		docs: "Documentation",
		settings: "Settings",
	},
	messages: {
		title: "Messages",
		noMessages: "No messages yet",
		channel: "Channel",
		status: "Status",
		recipient: "Recipient",
		createdAt: "Created At",
	},
	organizations: {
		title: "Organizations",
		name: "Name",
		slug: "Slug",
		members: "Members",
		createNew: "Create Organization",
	},
	apps: {
		title: "Apps",
		createNew: "Create App",
		name: "App Name",
		noApps: "No apps yet",
		createFirst: "Create your first app to get started.",
		selectApp: "Select an app",
		active: "Active",
		inactive: "Inactive",
		manageKeys: "Manage Keys",
		deleteConfirm: "Delete this app? All API keys will be removed.",
		settings: "App Settings",
	},
	apiKeys: {
		title: "API Keys",
		name: "Name",
		key: "API Key",
		prefix: "Key Prefix",
		lastUsed: "Last Used",
		never: "Never",
		active: "Active",
		inactive: "Inactive",
		createNew: "Create API Key",
		showOnce: "This key will only be shown once. Copy it now.",
		copyKey: "Copy Key",
		revoke: "Revoke",
		revokeConfirm: "Revoke this API key?",
		deleteConfirm: "Permanently delete this API key?",
	},
	senderIdentities: {
		title: "Sender Identities",
		createNew: "Add Domain",
		domain: "Domain",
		channel: "Channel",
		provider: "Provider",
		status: "Status",
		identifier: "Identifier",
		dnsRecords: "DNS Records",
		dnsType: "Type",
		dnsName: "Name",
		dnsValue: "Value",
		copyValue: "Copy",
		noIdentities: "No sender identities yet",
		createFirst: "Register a domain to start sending messages.",
		verifyNow: "Check Status",
		verifying: "Checking...",
		deleteConfirm: "Delete this sender identity? DNS records will be removed from the provider.",
		statusPending: "Pending",
		statusSuccess: "Verified",
		statusFailed: "Failed",
		statusTemporaryFailure: "Pending",
		noProviders: "No providers available for this channel yet.",
		addDnsInstructions: "Add the following DNS records to your domain to complete verification.",
	},
	apiDocs: {
		title: "API Usage",
		subtitle: "Send messages programmatically using the REST API.",
		baseUrl: "Base URL",
		authentication: "Authentication",
		authDescription: "Include your API key in the x-api-key header with every request.",
		manageKeys: "Manage API Keys",
		sendEmail: "Send Email",
		endpoint: "Endpoint",
		requestBody: "Request Body",
		response: "Response",
		rawContent: "Raw Content",
		templateContent: "Template",
		field: "Field",
		type: "Type",
		required: "Required",
		optional: "Optional",
		description: "Description",
		fieldReference: "Field Reference",
		errors: "Error Responses",
		copied: "Copied!",
		senderFromAddress: "Sender email address (must be from a verified domain)",
		senderFromName: "Display name for the sender",
		senderReplyTo: "Reply-to email address",
		destinationTo: "Array of recipient email addresses",
		destinationCc: "Array of CC email addresses",
		destinationBcc: "Array of BCC email addresses",
		contentType: 'Content type: "raw" or "template"',
		contentSubject: "Email subject line (raw only)",
		contentBody: "Email body as HTML (raw only)",
		contentTemplateId: "Template identifier (template only)",
		contentTemplateParams: "Key-value pairs for template variables (template only)",
		metadata: "Custom key-value metadata attached to the message",
		status202: "Message accepted for processing",
		status400: "Validation failed — check the request body",
		status401: "Missing or invalid API key",
	},
	settings: {
		title: "Settings",
		language: "Language",
		theme: "Theme",
		profile: "Profile",
	},
	billing: {
		eyebrow: "Billing",
		title: "Billing & Credits",
		balance: "Credit Balance",
		purchased: "Purchased",
		consumed: "Consumed",
		refunded: "Refunded",
		feesCharged: "Fees charged",
		usageThisPeriod: "Usage This Period",
		emailUsage: "Emails (free tier)",
		whatsappUsage: "WhatsApp",
		comingSoon: "Coming soon",
		buyCredits: "Buy Credits",
		amountUsd: "Amount (USD)",
		checkout: "Checkout",
		checkoutError: "Could not start checkout. Please try again.",
		managePortal: "Manage Billing",
		syncing: "Finalizing your purchase…",
	},
	org: {
		selectTitle: "Select Organization",
		selectSubtitle: "Choose an organization to continue",
		switchOrganization: "Switch Organization",
		noOrganizations: "No organizations yet",
		createFirst: "Create your first organization to get started.",
		createNew: "Create Organization",
		name: "Organization Name",
		slug: "Slug",
	},
	errors: {
		api: {
			INTERNAL_ERROR: "An unexpected error occurred",
			NOT_FOUND: "Resource not found",
			UNAUTHORIZED: "Please sign in again",
			PERMISSION_DENIED: "You don't have permission to perform this action",
			VALIDATION_ERROR: "Validation failed",
			PARSE_ERROR: "Unable to parse request",
			ORG_REQUIRED: "Organization is required",
			CONFLICT: "A resource with that identifier already exists",
		},
	},
};
